<!--登录页-->
<template>
  <div class="el-login">
    <el-row class="p10">
      <el-col :span="12" class="tc">
        <el-image style="max-width: 400px" :src="logo"></el-image>
      </el-col>
      <el-col :span="12" class="tc" style="line-height: 40px">
        <template v-for="(item, index) in headList">
          <el-link
            type="primary"
            :href="item.studentClientLinkContent"
            target="_blank"
            class="link_login"
            >{{ item.studentClientLinkTitle }}</el-link
          >
        </template>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="13" class="t_r">
        <el-image
          style="width: 500px; margin-top: 20%"
          :src="BG_icon"
        ></el-image>
      </el-col>
      <el-col :span="11">
        <!-- show_type：1 登陆 2：注册 3：找回密码  -->
        <template v-if="show_type == 1">
          <el-row class="box_login">
            <el-row>
              <el-col :span="8" class="tc">
                <el-link
                  :type="onLogin == 0 ? 'primary' : ''"
                  @click="loginType(0)"
                  :class="onLogin == 0 ? 'on_link _link' : '_link'"
                  :underline="false"
                  >账号登录</el-link
                >
              </el-col>
              <el-col :span="8" class="tc">
                <el-link
                  :type="onLogin == 2 ? 'primary' : ''"
                  @click="loginType(2)"
                  :class="onLogin == 2 ? 'on_link _link' : '_link'"
                  :underline="false"
                  >手机验证码</el-link
                >
              </el-col>
              <el-col :span="8" class="tc">
                <el-link
                  :type="onLogin == 1 ? 'primary' : ''"
                  @click="loginType(1)"
                  :class="onLogin == 1 ? 'on_link _link' : '_link'"
                  :underline="false"
                  >微信登录</el-link
                >
              </el-col>
            </el-row>
            <template v-if="onLogin == 0">
              <el-row class="el_form_">
                <el-input
                  v-model="userName"
                  placeholder="请输入账号"
                ></el-input>
              </el-row>
              <el-row class="el_form_">
                <el-input
                  v-model="password"
                  type="password"
                  show-password
                  placeholder="请输入密码"
                ></el-input>
              </el-row>
              <el-row class="el_form_">
                <el-col :span="14" class="tc pr20">
                  <el-input
                    v-model="code"
                    placeholder="请输入数字验证码"
                    @keyup.enter.native="onSubmit"
                  ></el-input>
                </el-col>
                <el-col :span="10" class="tc">
                  <p
                    class="m0"
                    style="
                      line-height: 38px;
                      border: 1px solid #e1e1e1;
                      border-radius: 3px;
                    "
                  >
                    <SIdentify ref="SIdentify"></SIdentify>
                  </p>
                </el-col>
              </el-row>
              <el-row class="el_form_ tl">
                <el-checkbox
                  label="1"
                  :checked="remember_password"
                  v-model="remember_password"
                  >记住密码</el-checkbox
                >
              </el-row>
              <el-row class="el_form_ tl">
                <el-button
                  type="primary"
                  :loading="sub_load"
                  @click="onSubmit"
                  style="width: 100%"
                  >登 录</el-button
                >
              </el-row>
              <el-row class="el_form_">
                <el-col :span="12" class="tl pr20">
                  <el-link type="primary" :underline="false" @click="register()"
                    >注册账号</el-link
                  >
                </el-col>
                <el-col :span="12" class="t_r">
                  <el-link type="primary" :underline="false" @click="editPwd"
                    >忘记密码</el-link
                  >
                </el-col>
              </el-row>
            </template>
            <template v-if="onLogin == 1">
              <el-row
                style="
                  width: 200px;
                  height: 200px;
                  margin: 0 auto;
                  margin-top: 16%;
                  padding: 10px;
                  border: 1px solid #e1e1e1;
                "
                v-loading="loadings"
                :element-loading-text="msgname"
              >
              </el-row>
              <p class="mt40">
                <el-link type="primary" @click="register()">注册账号</el-link>
              </p>
            </template>
            <template v-if="onLogin == 2">
              <el-row v-if="userList.length <= 0">
                <el-row class="el_form_">
                  <el-input
                    v-model="phone"
                    placeholder="请输入手机号"
                  ></el-input>
                </el-row>
                <el-row class="el_form_">
                  <el-input v-model="codes" placeholder="请输入验证码">
                    <template #append>
                      <el-button type="primary" @click="getVerificationCode">{{
                        time ? "" + time + "秒后重新获取" : "获取验证码"
                      }}</el-button>
                    </template>
                  </el-input>
                </el-row>
                <el-row class="el_form_ tl">
                  <el-button
                    type="primary"
                    @click="checkCode"
                    style="width: 100%"
                    >登 录</el-button
                  >
                </el-row>
              </el-row>

              <el-row
                class="el_form_"
                style="
                  justify-content: center;
                  margin-bottom: 20px;
                  display: flex;
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    width: 100%;
                    cursor: pointer;
                  "
                  v-for="item in userList"
                  :key="item.id"
                  @click="selectRole(item)"
                >
                  <el-avatar
                    :size="64"
                    :src="require(`../assets/${item.roleName}.png`)"
                    fit="cover"
                  ></el-avatar>
                  <div
                    style="
                      margin-top: 10px;
                      font-size: 18px;
                      color: #333;
                      font-weight: bold;
                    "
                  >
                    {{ item.studentId }}
                  </div>
                </div>
              </el-row>
            </template>
          </el-row>
        </template>

        <template v-if="show_type == 2">
          <el-row
            class="box_login"
            style="
              margin-top: 6%;
              padding-top: 10px;
              height: auto;
              width: 420px;
            "
          >
            <p style="color: #2789e2; font-weight: bold">新用户注册</p>
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="所属学校" required>
                <el-select
                  class="formSelect"
                  @change="getUniversityFacultyList()"
                  clearable
                  v-model="form.universitiesCollegesId"
                  filterable
                  placeholder="请选择"
                >
                  <template v-for="(item, index) in schoolList">
                    <el-option
                      :key="index + 'school'"
                      :label="item.universitiesCollegesName"
                      :value="item.universitiesCollegesId"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="所属院系" required>
                <el-select
                  class="formSelect"
                  @change="getUniversitySystemList()"
                  clearable
                  v-model="form.universityFacultyId"
                  filterable
                  placeholder="请选择"
                >
                  <template v-for="(item, index) in universityFacultyList">
                    <el-option
                      :key="index + 'universityFacultyList'"
                      :label="item.universityFacultyName"
                      :value="item.universityFacultyId"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="所属专业" required>
                <el-select
                  class="formSelect"
                  @change="getSchoolClassList()"
                  clearable
                  v-model="form.universitySystemId"
                  filterable
                  placeholder="请选择"
                >
                  <template v-for="(item, index) in universitySystemList">
                    <el-option
                      :key="index + 'universitySystemList'"
                      :label="item.universitySystemName"
                      :value="item.universitySystemId"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="所属班级" required>
                <el-select
                  class="formSelect"
                  clearable
                  v-model="form.classId"
                  filterable
                  placeholder="请选择"
                >
                  <template v-for="(item, index) in schoolClassList">
                    <el-option
                      :key="index + 'schoolClassList'"
                      :label="item.className"
                      :value="item.classId"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="学生姓名" required>
                <el-input v-model="form.studentName"></el-input>
              </el-form-item>
              <el-form-item label="学  号" required>
                <el-input v-model="form.studentSn"></el-input>
              </el-form-item>
              <el-form-item label="电话号码" required>
                <el-input v-model="form.studentMobile"></el-input>
              </el-form-item>
              <el-form-item label="电子邮箱" required>
                <el-input v-model="form.studentEmail"></el-input>
              </el-form-item>
              <el-form-item label="院校授权码" required>
                <el-input
                  v-model="form.universitiesCollegesAuthCode"
                ></el-input>
              </el-form-item>
              <el-row class="el_form_ tl">
                <el-button
                  type="primary"
                  :loading="sub_load"
                  @click="sub_register"
                  style="width: 100%"
                  >立即注册</el-button
                >
              </el-row>
              <p class="mt20">
                <el-link type="primary" @click="(show_type = 1), (onLogin = 0)"
                  >已有账号，立即登陆 >></el-link
                >
              </p>
            </el-form>
          </el-row>
        </template>
        <template v-if="show_type == 3">
          <el-row
            class="box_login"
            style="
              margin-top: 15%;
              padding-top: 10px;
              height: auto;
              width: 420px;
            "
          >
            <p style="color: #2789e2; font-weight: bold">忘记密码</p>
            <el-form ref="form" :model="pwdForm" label-width="80px">
              <el-form-item label="所属学校" required>
                <el-select
                  class="formSelect"
                  clearable
                  v-model="pwdForm.universitiesCollegesId"
                  filterable
                  placeholder="请选择"
                >
                  <template v-for="(item, index) in schoolList">
                    <el-option
                      :key="index + 'school'"
                      :label="item.universitiesCollegesName"
                      :value="item.universitiesCollegesId"
                    ></el-option>
                  </template>
                </el-select>
              </el-form-item>
              <el-form-item label="学生姓名" required>
                <el-input v-model="pwdForm.studentName"></el-input>
              </el-form-item>
              <el-form-item label="学  号" required>
                <el-input v-model="pwdForm.studentSn"></el-input>
              </el-form-item>
              <el-form-item label="院校授权码" required>
                <el-input
                  v-model="pwdForm.universitiesCollegesAuthCode"
                ></el-input>
              </el-form-item>
              <!-- <el-form-item label="旧密码" required>
                <el-input show-password v-model="pwdForm.oldPwd"></el-input>
              </el-form-item> -->
              <el-form-item label="新密码" required>
                <el-input show-password v-model="pwdForm.newPwd"></el-input>
              </el-form-item>
              <el-row class="el_form_ tl">
                <el-button
                  type="primary"
                  :loading="sub_load"
                  @click="sub_editPwd"
                  style="width: 100%"
                  >立即重置</el-button
                >
              </el-row>
              <p class="mt20">
                <el-link type="primary" @click="(show_type = 1), (onLogin = 0)"
                  >返回登陆 >></el-link
                >
              </p>
            </el-form>
          </el-row>
        </template>
      </el-col>
    </el-row>
    <div class="login_footer">
      天择智云教学平台系统 V1.0 &nbsp;&nbsp;粤ICP备17143346号
    </div>
  </div>
</template>

<script>
import SIdentify from "@/components/SIdentify"; //验证码
import QRCode from "qrcode";
export default {
  name: "Login",
  components: {
    SIdentify
  },
  data() {
    return {
      BG_icon: require("../images/login/BG-icon@2x.png"),
      logo: require("../images/login/logo@3x.png"),
      qrCode: "",
      headList: [], //头部List
      code: "",
      userName: "",
      password: "",
      token: "",
      userNameFocus: true,
      onLogin: 0,
      remember_password: false, //是否记住密码
      show_type: 1, //show_type：1 登陆 2：注册 3：找回密码
      sub_load: false,
      form: {
        universitiesCollegesId: "",
        universitySystemId: "",
        universityFacultyId: "",
        classId: ""
      },
      schoolList: [], //学校List
      universityFacultyList: [], //院系List
      universitySystemList: [], //专业List
      schoolClassList: [], //班级List
      pwdForm: {
        universitiesCollegesId: ""
      },
      sign: "stop",
      // 手机号
      phone: "",
      // 验证码
      codes: "",
      // 验证码倒计时
      time: 0,
      _timer: 0,
      userList: [],
      loadings: false,
      msgname: "正在进行扫码登录..."
    };
  },
  created() {
    this.userName = localStorage.getItem("userName") || "";
    let remember_password = localStorage.getItem("remember_password");
    if (remember_password) {
      //判断是否记住密码
      this.remember_password = true;
      let userPass = localStorage.getItem("userPass");
      if (userPass) {
        this.password = this.$Base64.decode(userPass);
      }
    }
    this.getInfo();
  },
  methods: {
    getInfo() {
      //获取头部
      this.$get("/api/studentClientLink/getList.do", {
        studentClientLinkType: "LOGIN_PAGE_NAV",
        studentClientLinkStatus: 1
      }).then(ret => {
        if (ret.code == 0) {
          this.headList = ret.data;
        }
      });
    },
    getUniversitiesCollegesList() {
      //获取学校信息
      this.form = {
        universitiesCollegesId: "",
        universitySystemId: "",
        universityFacultyId: "",
        classId: ""
      };
      if (this.schoolList.length > 0) {
        return;
      }
      this.$get("/api/universitiesColleges/getList.do").then(ret => {
        if (ret.code == 0) {
          this.schoolList = ret.data;
        }
      });
    },
    getUniversityFacultyList() {
      //获取所属院系
      this.universityFacultyList = []; //院系List
      this.universitySystemList = []; //专业List
      this.schoolClassList = []; //班级List
      this.form.universityFacultyId = ""; //学校ID
      this.form.universitySystemId = ""; //专业ID
      this.form.classId = ""; //班级ID
      if (this.$isEmpty(this.form.universitiesCollegesId)) {
        return;
      }
      this.$get("/api/universityFaculty/getList.do", {
        universitiesCollegesId: this.form.universitiesCollegesId
      }).then(ret => {
        if (ret.code == 0) {
          this.universityFacultyList = ret.data;
        }
      });
    },
    getUniversitySystemList() {
      //获取专业信息
      this.universitySystemList = []; //专业List
      this.schoolClassList = []; //班级List
      this.form.universitySystemId = ""; //专业ID
      this.form.classId = ""; //班级ID
      if (this.$isEmpty(this.form.universityFacultyId)) {
        return;
      }
      this.$get("/api/universitySystem/getList.do", {
        universityFacultyId: this.form.universityFacultyId
      }).then(ret => {
        if (ret.code == 0) {
          this.universitySystemList = ret.data;
        }
      });
    },
    getSchoolClassList() {
      //获取班级信息
      this.schoolClassList = []; //班级List
      this.form.classId = ""; //班级ID
      if (this.$isEmpty(this.form.universitySystemId)) {
        return;
      }
      this.$get("/api/schoolClass/getList.do", {
        universitySystemId: this.form.universitySystemId
      }).then(ret => {
        if (ret.code == 0) {
          this.schoolClassList = ret.data;
        }
      });
    },
    loginType(index) {
      //切换登陆方式 0：账号密码 1：微信
      this.onLogin = index;
      if (index == 1) {
        this.getLoginQrCode();
        this.loadings = true;
      } else {
        this.sign = "stop";
      }
    },
    register() {
      //注册
      this.sign = "stop";
      this.show_type = 2;
      this.form = {};
      this.getUniversitiesCollegesList();
    },
    onSubmit() {
      if (this.token == "") {
        if (this.userName == "") {
          this.$message.warning("请输入用户名！");
          return;
        }
        if (this.password == "") {
          this.$message.warning("请输入密码！");
          return;
        }
        if (this.code == "") {
          this.$message.warning("请输入验证码！");
          return;
        }
        let identifyCodeTemp = this.$refs.SIdentify.identifyCodeTemp; //验证码
        this.$refs.SIdentify.getCode();
        if (this.code != identifyCodeTemp) {
          this.$message.warning("验证码错误！");
          this.code = "";
          return;
        }
        this.sub_load = true;
      }
      //this.$cookies.remove("JSESSIONID");
      this.$post("/login.json", {
        code: this.userName,
        password: this.password,
        TOKEN: this.token
      })
        .then(ret => {
          this.sub_load = false;
          if (ret.code === 0 || ret.code === "0") {
            localStorage.setItem("remember_password", this.remember_password);
            if (this.remember_password) {
              localStorage.setItem(
                "userPass",
                this.$Base64.encode(this.password)
              ); //密码加密并且存入缓存
            }
            localStorage.setItem("userName", this.userName);
            if (ret.data != null) {
              //this.$ls.set(ret.data.loginTime,ret.data.token_key); //根据唯一值存入当前用户token的唯一值 name
              localStorage.setItem("hasBoundMobile", ret.data.hasBoundMobile);
              window.location.href =
                this.$baseUrl + "/index.do?_role_tag=" + ret.data.loginTime;
            } else {
              window.location.href = this.$baseUrl + "/index.do";
            }
          } else {
            //登录失败必须给出提示：原来只写了成功分支，账号或密码错误时页面毫无反应
            this.loginFailTip(ret);
          }
        })
        .catch(err => {
          this.sub_load = false;
          //有响应体的错误请求拦截器里已经弹过提示了，这里只兜底网络/超时
          if (!err || !err.response) {
            this.$message({
              message: "网络异常，请检查网络后重试",
              type: "error",
              duration: 4000,
              showClose: true
            });
          }
          this.code = "";
        });
    },
    loginFailTip(ret) {
      //401 的提示由请求拦截器统一弹出，这里不再重复弹
      let isHandled = ret && (ret.code == 401 || ret.code === "401");
      if (!isHandled) {
        let msg = ret && !this.$isEmpty(ret.msg) ? String(ret.msg) : "";
        this.$message({
          message: msg || "登录失败，请检查账号和密码是否正确",
          type: "error",
          duration: 4000,
          showClose: true
        });
      }
      //提交时验证码图片已经刷新过，输入框不清空的话下次会莫名报"验证码错误"
      this.code = "";
    },
    sub_register() {
      //提交注册信息
      if (this.$isEmpty(this.form.universitiesCollegesId)) {
        this.$message.warning("请选择所属学校！");
        return;
      }
      if (this.$isEmpty(this.form.universityFacultyId)) {
        this.$message.warning("请选择所属院系！");
        return;
      }
      if (this.$isEmpty(this.form.universitySystemId)) {
        this.$message.warning("请选择所属专业！");
        return;
      }
      if (this.$isEmpty(this.form.classId)) {
        this.$message.warning("请选择所属班级！");
        return;
      }
      if (this.$isEmpty(this.form.studentName)) {
        this.$message.warning("请输入学生姓名！");
        return;
      }
      if (this.$isEmpty(this.form.studentMobile)) {
        this.$message.warning("请输入电话号码！");
        return;
      }
      if (this.$isEmpty(this.form.universitiesCollegesAuthCode)) {
        this.$message.warning("请输入院校授权码！");
        return;
      }
      this.sub_load = true;
      this.$post("/api/student/register.do", this.form)
        .then(ret => {
          this.sub_load = false;
          if (ret.code === 0 || ret.code === "0") {
            this.form = {
              universitiesCollegesId: "",
              universitySystemId: "",
              universityFacultyId: "",
              classId: ""
            };
            this.show_type = 1;
            this.$message({ message: "注册成功！", type: "success" });
          } else {
            this.$message({
              message: ret.msg,
              type: "warning"
            });
          }
        })
        .catch(err => {
          this.sub_load = false;
        });
    },
    editPwd() {
      //忘记密码
      this.show_type = 3;
      this.pwdForm = {};
      this.getUniversitiesCollegesList();
    },
    sub_editPwd() {
      //提交密码找回
      if (this.$isEmpty(this.pwdForm.universitiesCollegesId)) {
        this.$message.warning("请选择所属学校！");
        return;
      }
      if (this.$isEmpty(this.pwdForm.studentName)) {
        this.$message.warning("请输入学生姓名！");
        return;
      }
      if (this.$isEmpty(this.pwdForm.studentSn)) {
        this.$message.warning("请输入学号！");
        return;
      }
      if (this.$isEmpty(this.pwdForm.universitiesCollegesAuthCode)) {
        this.$message.warning("请输入院校授权码！");
        return;
      }
      // if (this.$isEmpty(this.pwdForm.oldPwd)) {
      //   this.$message.warning("请输入旧密码！");
      //   return;
      // }
      if (this.$isEmpty(this.pwdForm.newPwd)) {
        this.$message.warning("请输入新密码！");
        return;
      }
      this.sub_load = true;
      this.$post("/api/student/editPwd.do", this.pwdForm)
        .then(ret => {
          this.sub_load = false;
          if (ret.code == 0) {
            this.$message({ message: "提交成功！", type: "success" });
          } else {
            this.$message({ message: ret.msg, type: "warning" });
          }
        })
        .catch(err => {
          this.sub_load = false;
        });
    },
    isJsonString(str) {
      try {
        const obj = JSON.parse(str);
        return typeof obj === "object" || Array.isArray(obj);
      } catch (e) {
        return false;
      }
    },
    getLoginQrCode() {
      //获取公众号登录二维码
      this.sign = "loading";
      this.$get("/wx/api/getLoginQrCode")
        .then(ret => {
          if (ret.code == 0) {
            const qrWindow = window.open(ret.data.qrCodeUrl, "about:blank");
            const ws = new WebSocket(
              "wss://zycloud.sztzjy.com/server/ws/" + ret.data.state
            );
            // 接收消息
            ws.onmessage = e => {
              let msg;
              if (typeof e.data === "string" && this.isJsonString(e.data)) {
                msg = JSON.parse(e.data);
              } else {
                msg = e.data;
              }
              if (!msg.data) {
                this.$message({ message: msg, type: "warning" });
                this.msgname = msg;
                if (qrWindow && !qrWindow.closed) {
                  qrWindow.close();
                }
                return;
              }
              // ✅ 关闭扫码窗口
              if (qrWindow && !qrWindow.closed) {
                qrWindow.close();
              }
              this.msgname = "正在进行扫码登录...";
              // 成功
              if (msg.data.loginTime != null && msg.data.token_key != null) {
                this.$cookies.set(msg.data.loginTime, msg.data.token_key);
                setTimeout(() => {
                  window.location.href =
                    this.$baseUrl + "/index.do?_role_tag=" + msg.data.loginTime;
                }, 1000);
              } else {
                window.location.href = this.$baseUrl + "/index.do";
              }
            };
            // 失败
            ws.onerror = e => {
              this.$message({ message: e, type: "warning" });
              if (qrWindow && !qrWindow.closed) {
                qrWindow.close();
              }
            };
          } else {
            this.$message({ message: ret.msg, type: "warning" });
          }
        })
        .catch(err => {});
    },
    getLoginAndBindStatus() {
      //获取扫码状态
      this.$get("/wx/api/getLoginAndBindStatus", {
        type: "login"
      })
        .then(ret => {
          if (ret.status == "warning" && this.sign == "loading") {
            //等待回应时继续轮询访问
            setTimeout(() => {
              //未返回
              this.getLoginAndBindStatus();
            }, 2000);
          } else if (this.sign == "loading") {
            this.sign = "stop";
            if (ret.status == "success") {
              //成功
              if (ret.loginTime != null && ret.token_key != null) {
                this.$cookies.set(ret.token_key, ret.token);
                this.$cookies.set(ret.loginTime, ret.token_key); //根据唯一值存入当前用户token的唯一值 name
                window.location.href =
                  this.$baseUrl + "/index.do?_role_tag=" + ret.loginTime;
              } else {
                window.location.href = this.$baseUrl + "/index.do";
              }
            } else {
              this.$message({ message: ret.token, type: "warning" });
            }
          }
        })
        .catch(err => {});
    },

    // 获取验证码
    getVerificationCode() {
      if (this.$isEmpty(this.phone)) {
        this.$message.warning("请输入手机号！");
        return;
      }
      // 对手机号进行校验
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.phone)) {
        this.$message.warning("请输入正确的11位手机号！");
        return;
      }
      if (this.time > 0 && this.time < 60) {
        this.$message.warning(`请${this.time}秒后再获取验证码！`);
        return;
      }
      this.$post("/sendCode.json", {
        phoneNumber: this.phone,
        type: 1
      })
        .then(ret => {
          if (ret.code == 0) {
            this.$message({ message: "验证码已发送！", type: "success" });
            this.time = 60;
            this.startCountdown();
          } else {
            //发送失败要给提示，否则用户只看到"没收到短信"不知道原因
            this.$message({
              message: ret.msg || "验证码发送失败，请稍后重试",
              type: "error",
              duration: 4000,
              showClose: true
            });
          }
        })
        .catch(err => {});
    },
    startCountdown() {
      if (this._timer) {
        clearInterval(this._timer);
      }
      this._timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          clearInterval(this._timer);
          this._timer = null;
        }
      }, 1000);
    },
    // 获取验证码后对验证码进行校验
    checkCode() {
      if (this.$isEmpty(this.phone)) {
        this.$message.warning("请输入手机号！");
        return;
      }
      if (this.$isEmpty(this.codes)) {
        this.$message.warning("请输入验证码！");
        return;
      }
      this.$post("/smsLogin.json", {
        phoneNumber: this.phone,
        smsCode: this.codes,
        type: 1
      })
        .then(ret => {
          clearInterval(this._timer);
          this.time = 0;
          //先判 code：原来失败时 data 为空会直接跳到首页，等于把用户"踢走"且提示来不及看
          if (ret.code != null && ret.code != 0 && ret.code !== "0") {
            this.$message({
              message: ret.msg || "验证码错误或已失效，请重新获取",
              type: "error",
              duration: 4000,
              showClose: true
            });
            return;
          }
          if (Array.isArray(ret.data)) {
            this.$message({ message: "验证码正确！", type: "success" });
            this.isCode = true;
            this.userList = ret.data;
          } else {
            if (ret.data != null) {
              this.$ls.set(ret.data.loginTime, ret.data.token_key); //根据唯一值存入当前用户token的唯一值 name
              window.location.href =
                this.$baseUrl + "/index.do?_role_tag=" + ret.data.loginTime;
            } else {
              window.location.href = this.$baseUrl + "/index.do";
            }
            this.$message({
              message: ret.msg || "返回数据格式错误",
              type: "warning"
            });
          }
        })
        .catch(err => {});
    },
    selectRole(row) {
      console.log(this.userList, "this.userList", row);
      this.$post("/smsLoginConfirm.json", {
        TOKEN: row.token,
        studentId: row.studentId,
        userId: row.userId
      })
        .then(ret => {
          if (ret.code != null && ret.code != 0 && ret.code !== "0") {
            this.$message({
              message: ret.msg || "登录失败，请重试",
              type: "error",
              duration: 4000,
              showClose: true
            });
            return;
          }
          if (ret.data != null) {
            //this.$ls.set(ret.data.loginTime,ret.data.token_key); //根据唯一值存入当前用户token的唯一值 name
            window.location.href =
              this.$baseUrl + "/index.do?_role_tag=" + ret.data.loginTime;
          } else {
            if (ret.code == 500) {
              this.$message({ message: ret.msg, type: "warning" });
            } else {
              window.location.href = this.$baseUrl + "/index.do";
            }
          }
        })
        .catch(err => {});
    },
    clearAccountInfo() {
      this.userList = [];
      this.codes = "";
    }
  },
  watch: {
    "$route.query": {
      handler(newQuery) {
        if (newQuery.TOKEN) {
          this.token = newQuery.TOKEN;
          console.log("444444");
          return this.onSubmit();
        }
        // 在这里处理query参数变化后的逻辑
      },
      immediate: true // 立即触发回调，以确保初始状态也被处理
    }
  }
};
</script>
<style lang="less">
@import "../styles/style.less";
.el-main {
  height: 100vh !important;
  overflow: auto;
  padding: 0 !important;
}
.el-login {
  height: 100vh;
  overflow: auto;
  background-image: url("../images/login/BG@2x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  min-width: 1200px;
  position: relative;
  .box_login {
    border-radius: 3px;
    margin-left: 100px;
    width: 360px;
    margin-top: 18%;
    text-align: center;
    background-color: #ffffff;
    height: 430px;
    padding: 20px;
  }
  .link_login {
    color: #ffffff;
    margin: 0 20px;
  }
  ._link {
    font-weight: bold;
    font-size: 16px;
  }
  .on_link {
    border-bottom: 2px solid;
    padding-bottom: 10px;
  }
  .el_form_ {
    margin-top: 25px;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-form-item__label {
    width: 100px !important;
  }
  .el-form-item__content {
    margin-left: 100px !important;
  }
  .formSelect {
    width: 100%;
  }
  .login_footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    background-color: #0263d3;
    color: #fff;
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue